import script from "./SpeedControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpeedControl.vue?vue&type=script&setup=true&lang=ts"

import "./SpeedControl.vue?vue&type=style&index=0&id=4a32d594&lang=less"

const __exports__ = script;

export default __exports__